import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRefresh(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        d="M20 12v6l-1.579-.961-.54.598c-.04.043-.07.074-.083.086A8.15 8.15 0 0112.136 20c-3.746 0-6.901-2.49-7.847-5.878l1.836-1.087C6.625 15.852 9.129 18 12.136 18c1.493 0 2.877-.508 3.918-1.414l.238-.214c.16-.146.313-.29.405-.377L15 14.968 20 12zm-8.136-8c3.81 0 7.008 2.575 7.893 6.05l-1.864 1.02C17.437 8.2 14.907 6 11.864 6c-1.493 0-2.877.508-3.918 1.414l-.238.214c-.16.146-.313.29-.405.377L9 9.032 4 12V6l1.579.961.54-.598c.04-.043.07-.074.083-.086A8.15 8.15 0 0111.864 4z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Refresh')(SvgRefresh);
